import { render, staticRenderFns } from "./CustomOrderView.vue?vue&type=template&id=f37811d4&"
import script from "./CustomOrderView.vue?vue&type=script&lang=js&"
export * from "./CustomOrderView.vue?vue&type=script&lang=js&"
import style0 from "./CustomOrderView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports